import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';
import { CvCvSection, CvSection, UpdateCvRequest, Cv } from '@/../gen';

interface CvParams {
  id: number;
}

export const namespace = 'cv_setting';
const actionCreator = actionCreatorFactory(namespace);
export const GetCv = actionCreator<{ cv_id: number }>('GET_CV');
export const CvFetched = actionCreator<Cv>('CV_FETCHED');
export const UpdateCv = actionCreator<{
  params: CvParams;
  body: UpdateCvRequest;
}>('UPDATE_CV');
export const DeleteCv = actionCreator<{ params: CvParams }>('DELETE_CV');

export interface CvCvSectionWithSection extends CvCvSection {
  section: CvSection;
  sectionItems: any[];
}

export const ResetState = actionCreator<null>('RESET_STATE');

export interface State {
  cv: Cv;
}

const initialState = (): State => {
  return { cv: null };
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(GetCv, async function(context, action) {
      const { data } = await this.proffApi.getCv(action.payload.cv_id);
      context.commit(CvFetched(data.data.attributes));
    }),
    action(UpdateCv, async function(context, action) {
      const { params, body } = action.payload;
      const { data } = await this.proffApi.updateCv(params.id, body);
      context.commit(CvFetched(data.data.attributes));
    }),
    action(DeleteCv, async function(context, action) {
      const { params } = action.payload;
      await this.proffApi.deleteCv(params.id);
      context.commit(CvFetched(null));
    }),
    action(ResetState, function(context, action) {
      context.commit(ResetState(action.payload));
    })
  ),
  mutations: combineMutation(
    mutation(CvFetched, (state, action) => {
      state.cv = action.payload;
    }),
    mutation(ResetState, state => {
      Object.assign(state, initialState());
    })
  ),
  getters: {
    cv: state => state.cv,
  },
};
